module.exports = __webpack_public_path__ + "static/media/marketplace.c58583ec.svg";